import { FacilityLevelsOfCareChart } from '@/entities/facility';
import type { FacilityLevelsOfCareDto } from '@/shared/api/modules/facilities';
import { LengthOfStayChart } from '@/widgets/length-of-stay-chart';
import type { Dayjs } from 'dayjs';
import { useState, type FC } from 'react';
import { LevelsOfCareTabs } from './levels-of-care-tabs';

type LevelsOfCareTabProps = {
  /** Omit for the All Facilities view — aggregates across accessible facilities. */
  facilityId?: string;
  dateRange: {
    from: Dayjs;
    to: Dayjs;
  };
};

export const LevelsOfCareTab: FC<LevelsOfCareTabProps> = ({
  facilityId,
  dateRange,
}) => {
  const [hoveredLevel, setHoveredLevel] = useState<number | null>(null);

  const onRowHover = (data: FacilityLevelsOfCareDto) => {
    setHoveredLevel(data.levelOfCare);
  };

  const onHoverEnd = () => setHoveredLevel(null);
  return (
    <div className="flex flex-col gap-4">
      {/* "Resident Pay Across All Care Levels" is a single-facility view and is
          dropped in Multiple Mode, per card #157 Part 1. */}
      {facilityId !== undefined && (
        <LengthOfStayChart dateRange={dateRange} facilityId={facilityId} />
      )}

      <FacilityLevelsOfCareChart
        dateRange={dateRange}
        facilityId={facilityId}
        hoveredLevel={hoveredLevel}
        onHoverEnd={onHoverEnd}
        onLevelLabelHover={onRowHover}
      />

      <LevelsOfCareTabs
        dateRange={dateRange}
        facilityId={facilityId}
        onHoverEnd={onHoverEnd}
        onRowHover={onRowHover}
      />
    </div>
  );
};
